import ChartFilters from './ChartFilters';
import { useAuth } from 'context/AuthContext';
import ChartQuarterOptions from './ChartQuarterOptions';

interface ChartOptionsProps {
  title: string;
  isAvgDealSizeSwitchDisabled: boolean;
  isQuartileMedianSwitchDisabled: boolean;
}

const ChartOptions = ({
  title,
  isAvgDealSizeSwitchDisabled,
  isQuartileMedianSwitchDisabled
}: ChartOptionsProps) => {
  const { isPortCo } = useAuth();

  return (
    <div className='relative flex items-center gap-4 mt-4'>
      {isPortCo && <ChartQuarterOptions />}

      <ChartFilters
        chartTitle={title}
        isAvgDealSizeSwitchDisabled={isAvgDealSizeSwitchDisabled}
        isQuartileMedianSwitchDisabled={isQuartileMedianSwitchDisabled}
      />
    </div>
  );
};

export default ChartOptions;
